// extracted by mini-css-extract-plugin
export var dividerLine = "_66-3";
export var itemImage = "_66-9";
export var lightDivider = "_66-4";
export var modalContent = "_66-5";
export var modalContentCompact = "_66-6";
export var productCard = "_66-a";
export var productImage = "_66-b";
export var productImageCompact = "_66-7";
export var productImagePlaceholder = "_66-c";
export var productImagePlaceholderCompact = "_66-8";
export var progressBarBackground = "_66-1";
export var progressBarContainer = "_66-0";
export var progressBarFill = "_66-2";